import { Region } from '@coveo/platform-client';
import { URLConstant } from '../constants/URLConstant.js';
import { RegionHelper } from './RegionHelper.js';
import { ENVIRONMENT } from '../types/EnvironmentType.js';
var getEnvFromDocumentURL = function getEnvFromDocumentURL(origin, region) {
    var parameters = new URLSearchParams(window.location.search);
    // look for the env in the querystring Should only be used when debugging
    for(var currentEnvironment in URLConstant.UI_HOSTNAMES){
        if (Object.prototype.hasOwnProperty.call(URLConstant.UI_HOSTNAMES, currentEnvironment)) {
            for(var i = 0; i < URLConstant.UI_HOSTNAMES[currentEnvironment].length; i++){
                if (parameters.get(URLConstant.UI_HOSTNAMES[currentEnvironment][i]) !== null) {
                    return currentEnvironment;
                }
            }
        }
    }
    // real lookup of the environment
    for(var currentEnvironment1 in URLConstant.UI_HOSTNAMES){
        if (Object.prototype.hasOwnProperty.call(URLConstant.UI_HOSTNAMES, currentEnvironment1)) {
            for(var i1 = 0; i1 < URLConstant.UI_HOSTNAMES[currentEnvironment1].length; i1++){
                var isOriginUs = origin.includes('-us') && region === Region.US;
                if (origin.includes(RegionHelper.injectRegion(URLConstant.UI_HOSTNAMES[currentEnvironment1][i1], region, isOriginUs))) {
                    return currentEnvironment1;
                }
            }
        }
    }
    return ENVIRONMENT.local;
};
var getDefaultEndpoint = function getDefaultEndpoint(defaultEndpoint, region) {
    if (typeof defaultEndpoint === 'string') {
        return RegionHelper.injectRegion(defaultEndpoint, region);
    }
    if (Array.isArray(defaultEndpoint)) {
        return defaultEndpoint.map(function(endpoint) {
            return RegionHelper.injectRegion(endpoint, region);
        });
    }
    return '';
};
/**
 * Determines whether the current document origin is a known production, stg, or hipaa host.
 * Used to prevent querystring-based env spoofing (e.g., `?dev` on a production URL)
 * from enabling the URL override mechanism.
 */ var isNonDevOrigin = function isNonDevOrigin() {
    var hostname = window.location.hostname;
    var nonDevEnvironments = [
        ENVIRONMENT.production,
        ENVIRONMENT.stg,
        ENVIRONMENT.hipaa
    ];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = nonDevEnvironments[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var nonDevEnv = _step.value;
            var _URLConstant_UI_HOSTNAMES_nonDevEnv;
            var hostPatterns = (_URLConstant_UI_HOSTNAMES_nonDevEnv = URLConstant.UI_HOSTNAMES[nonDevEnv]) !== null && _URLConstant_UI_HOSTNAMES_nonDevEnv !== void 0 ? _URLConstant_UI_HOSTNAMES_nonDevEnv : [];
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = hostPatterns[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var pattern = _step1.value;
                    // Skip simple env names like 'production', 'stg', 'hipaa' — they are querystring keys, not hostnames
                    if (!pattern.includes('.')) {
                        continue;
                    }
                    // Replace {region} with a regex that matches empty string or -<region>
                    var regexStr = pattern.replace(/\{region\}/g, '(-[a-z]+)?');
                    if (new RegExp(regexStr).test(hostname)) {
                        return true;
                    }
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return false;
};
var getServiceUrl = function getServiceUrl(env, region, queryParam, defaultEndpoint) {
    // Layer 1: Only allow URL overrides in local/dev environments AND when the document
    // origin is not a known production/stg/hipaa host. This prevents querystring-based env
    // spoofing (e.g., ?dev on a production URL) from enabling the override.
    if (env !== ENVIRONMENT.local && env !== ENVIRONMENT.dev) {
        return getDefaultEndpoint(defaultEndpoint, region);
    }
    if (isNonDevOrigin()) {
        return getDefaultEndpoint(defaultEndpoint, region);
    }
    var parameters = new URLSearchParams(window.location.search);
    var paramValue = parameters.get(queryParam);
    if (paramValue) {
        var parsedUrl;
        try {
            parsedUrl = new URL(paramValue);
        } catch (unused) {
            return getDefaultEndpoint(defaultEndpoint, region);
        }
        if (parsedUrl.protocol !== 'https:' && parsedUrl.protocol !== 'http:') {
            return getDefaultEndpoint(defaultEndpoint, region);
        }
        var hostname = parsedUrl.hostname;
        var isAllowed = hostname.endsWith('.cloud.coveo.com') || hostname === 'localhost' || hostname.endsWith('.corp.coveo.com') || hostname.endsWith('.stratus.coveo.com');
        if (isAllowed) {
            return "".concat(parsedUrl.protocol, "//").concat(parsedUrl.host);
        }
    }
    return getDefaultEndpoint(defaultEndpoint, region);
};
var getApplicationBaseUrls = function getApplicationBaseUrls(env) {
    return {
        'commerce-hub': URLConstant.APPLICATION_COMMERCE_HUB_BASE_URL[env],
        'knowledge-hub': URLConstant.APPLICATION_KNOWLEDGE_HUB_BASE_URL[env],
        'admin-ui': URLConstant.APPLICATION_PLATFORM_BASE_URL[env],
        docs: URLConstant.ONLINE_HELP_BASE_URL[env]
    };
};
export var URLHelper = {
    getEnvFromDocumentURL: getEnvFromDocumentURL,
    getServiceUrl: getServiceUrl,
    getApplicationBaseUrls: getApplicationBaseUrls
};

//# sourceMappingURL=URLHelper.js.map